<div class="main-alert main-{{ color }}-color">
  <mat-icon svgIcon="{{ icon }}"></mat-icon>
  <mat-label class="alert-message"><ng-content></ng-content></mat-label>
</div>
